import React from 'react'

// Components
import Header from '../components/Header'
import Vagas from '../components/Vagas'
import Button from '../components/Commons/Button'
import Footer from '../components/Footer'

const vagasPage = () =>
  <div>
    <Header name="site-header" style={{paddingBottom: '150px', marginBottom: '-130px'}}>
      <div className="container">
        <div className="grid-center">
           <div className="col-8_md-10 grid-column content center">
             <h1>
               Faça parte do nosso time.
             </h1>
             <p>O Talkative tem natureza colaborativa, ou seja, você também pode juntar-se à nossa equipe.</p>
             <Button name="white" text="Lista de vagas"  style={{margin: '0 auto'}} />
           </div>
        </div>
      </div>
    </Header>
    <Vagas />
    <Footer />
  </div>

export default vagasPage



// WEBPACK FOOTER //
// ./src/pages/vagas.js